// A banner setting's `value` holds either a JSON array of slides
// ([{ image, link }]) or, for settings saved before the slider existed,
// a plain image URL string. This normalizes both into a slide array.
export const parseBannerSlides = (value) => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) {
      return parsed
        .filter((slide) => slide && slide.image)
        .map((slide) => ({ image: slide.image, link: slide.link || "" }));
    }
  } catch (err) {
    // Not JSON: fall through and treat the raw value as a single image URL.
  }

  return [{ image: value, link: "" }];
};
